import TypeToReducer from 'type-to-reducer';
import cloneDeep from 'lodash/cloneDeep';
import uuid from 'uuid';
import {
  ADD_LOCATION,
  GET_LOCATIONS,
  MODIFY_LOCATION,
  REMOVE_LOCATION,
  UPDATE_LOCATIONS,
} from 'locations/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

export const findAndRemove = (locations, id) => {
  const found = locations.findIndex((l) => l.id === id);

  if (found > -1) {
    if (!locations[found].new) locations[found].deleted = true;
    else locations.splice(found, 1);
  } else {
    locations = locations.map((location) => {
      location._childs = findAndRemove(location._childs, id);
      return location;
    });
  }

  return locations;
};

export const findAndAdd = (locations, id) => {
  const newLocation = {
    id: uuid.v4(),
    _childs: [],
    _parent: id,
    active: true,
    deleted: false,
    name: '',
    new: true,
  };
  if (!id) {
    locations.unshift(newLocation);
  } else {
    const found = locations.findIndex((l) => l.id === id);
    if (found > -1) {
      locations[found]._childs.unshift(newLocation);
    } else {
      locations = locations.map((location) => {
        location._childs = findAndAdd(location._childs, id);
        return location;
      });
    }
  }
  return locations;
};

export const findAndModify = (locations, id, payload) => {
  const found = locations.findIndex((l) => l.id === id);
  if (found > -1) {
    locations[found] = { ...locations[found], ...payload };
  } else {
    locations = locations.map((location) => {
      location._childs = findAndModify(location._childs, id, payload);
      return location;
    });
  }
  return locations;
};

export const initialState = {
  isLoading: false,
  isSaving: false,
  locations: [],
};

export const getPending = (state) => ({ ...state, isLoading: true });
export const getRejected = (state) => ({ ...state, isLoading: false });
export const getFulfilled = (state, { payload }) => ({
  ...state,
  locations: [...payload.records],
  isLoading: false,
});

export const updatePending = (state) => ({ ...state, isSaving: true });
export const updateRejected = (state) => ({ ...state, isSaving: false });
export const updateFulfilled = (state) => ({ ...state, isSaving: false });

export const removeLocation = (state, { payload }) => {
  let { locations } = state;
  locations = findAndRemove(locations, payload);
  return { ...state, locations: cloneDeep(locations) };
};

export const addLocation = (state, { payload }) => {
  let { locations } = state;
  locations = findAndAdd(locations, payload);
  return { ...state, locations: cloneDeep(locations) };
};

export const modifyLocation = (state, { meta, payload }) => {
  let { locations } = state;
  locations = findAndModify(locations, meta.id, payload);
  return { ...state, locations: cloneDeep(locations) };
};

const reducers = {
  [REMOVE_LOCATION]: removeLocation,
  [ADD_LOCATION]: addLocation,
  [GET_LOCATIONS]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
  [UPDATE_LOCATIONS]: {
    [PENDING]: updatePending,
    [REJECTED]: updateRejected,
    [FULFILLED]: updateFulfilled,
  },
  [MODIFY_LOCATION]: modifyLocation,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/reducers/locations_reducers.js